import { defineStore } from 'pinia'

import { getToken, setToken, removeToken, getName, setName, removeName } from '@/utils/auth'
import router from '@/router'
export const useUserStore = defineStore('login', {
    state: () => ({
        acid: null,
        token:getToken(),
        isLogin:!!getToken(),
        name:getName(),
    }),
    actions: {
        setAcid(acid) {
            this.acid = acid
        },
        setToken(token) {
            setToken(token);
            this.token      = token;
            this.isLogin    = true;
        },
        setName(name) {
            setName(name);
            this.name = name;
        },
        loginIn(token,name, acid){
            setToken(token)
            setName(name)
            this.name=name
            this.token=token;
            this.isLogin=true;
            this.setAcid(acid);
        },
        loginOut(){
            removeToken()
            removeName()
            this.token='';
            this.name='';
            this.isLogin=false;
            router.push('/login')
        }
    },
}, { 
    persist: {
        enabled: true,
        strategies: [{
            storage: localStorage,
            paths: ["acid", "token", 'name']
        }],
    }
});
